import { Firebase } from "@/app/core/base/FirebaseApp";
import { toast } from "react-toastify";
import {
  getFirestore,
  collection,
  getDocs,
  updateDoc,
  doc,
  getDoc,
  Timestamp,
  getCountFromServer,
  query,
  where,
  addDoc,
  deleteDoc,
  setDoc,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { httpsCallable } from "firebase/functions";
import { ErrorHelper } from "../../util/helpers/ErrorHelper";
import { FireHelper } from "../../util/helpers/FireHelper";
import { DateHelper } from "../../util/helpers/DateHelper";
import algoliasearch from "algoliasearch";
import { ComplainHelper } from "../../util/helpers/ComplainHelper";
import Storage from "../../util/Storage";
import Functions from "../../util/Functions";

export const PagarMeController = {
  auth: getAuth(Firebase),
  functions: getFunctions(Firebase),

  CreateCardToken: async function (data) {
    try {
      const currentUser = this.auth.currentUser;
      if (!currentUser) {
        toast.error("User not authenticated");
        return null;
      }

      const createCardToken = httpsCallable(this.functions, "createCardToken");
      const cardResponse = await createCardToken({
        number: data.number,
        holderName: data.holderName,
        expMonth: data.expMonth,
        expYear: data.expYear,
        cvv: data.cvv,
      });

      if (!cardResponse.data) {
        console.error("CreateCardToken", cardResponse.data);
        throw new Error("Invalid response from Cloud Function");
      }

      const cardData = cardResponse.data;
      const cardDataExtracted = {
        result: {
          id: cardData.id,
          type: cardData.type,
          created_at: cardData.created_at,
          expires_at: cardData.expires_at,
          card: {
            first_six_digits: cardData.card.first_six_digits,
            last_four_digits: cardData.card.last_four_digits,
            holder_name: cardData.card.holder_name,
            exp_month: cardData.card.exp_month,
            exp_year: cardData.card.exp_year,
          },
        },
      };

      return cardDataExtracted;
    } catch (e) {
      console.error("PagarMeController Tokenize error", e);
      toast.error(e.toString());
      return null;
    }
  },

  CreateOrder: async function (data) {
    const currentUser = this.auth.currentUser;
    if (!currentUser) {
      toast.error("User not authenticated");
      return null;
    }

    const req = Functions.RemoveUndefinedFields({
      closed: data.closed,
      complainId: data.complainId,
      customer: {
        code: data.customer.code,
        name: data.customer.name,
        email: data.customer.email,
        document: data.customer.document,
        documentType: data.customer.documentType,
        type: data.customer.type,
        phones: data.customer.phones &&
          data.customer.phones.mobilePhone && {
            mobilePhone: {
              countryCode: data.customer.phones.mobilePhone.countryCode,
              areaCode: data.customer.phones.mobilePhone.areaCode,
              number: data.customer.phones.mobilePhone.number,
            },
          },
      },
      items: data.items.map((item) => ({
        amount: item.amount,
        code: item.code,
        description: item.description,
        quantity: item.quantity,
      })),
      payments: data.payments.map((payment) => ({
        paymentMethod: payment.paymentMethod,
        creditCard:
          payment.paymentMethod === "credit_card"
            ? {
                recurrence: payment.creditCard.recurrence,
                installments: payment.creditCard.installments,
                statementDescriptor: payment.creditCard.statementDescriptor,
                cardToken: payment.creditCard.cardToken,
                card: {
                  billingAddress: {
                    line1: payment.creditCard.card.billingAddress.line1,
                    zipCode: payment.creditCard.card.billingAddress.zipCode,
                    city: payment.creditCard.card.billingAddress.city,
                    state: payment.creditCard.card.billingAddress.state,
                    country: payment.creditCard.card.billingAddress.country,
                  },
                },
              }
            : undefined,
      })),
    });

    const createOrder = httpsCallable(this.functions, "createOrder");
    const orderResponse = await createOrder(req);
    if (!orderResponse.data) {
      throw new Error("Invalid response from Cloud Function");
    }

    const orderData = orderResponse.data;
    return orderData;
  },

  GetOrder: async function (orderId) {
    const currentUser = this.auth.currentUser;
    if (!currentUser) {
      toast.error("User not authenticated");
      return null;
    }

    const getOrder = httpsCallable(this.functions, "getOrder");
    const orderResponse = await getOrder({
      orderId: orderId,
    });

    if (!orderResponse.data) {
      throw new Error("Invalid response from Cloud Function");
    }

    const orderData = orderResponse.data;
    return orderData;
  },
};
